export enum TeamShareMapPermission {
  Owner = 'Owner',
  Contributor = 'Contributor',
  ViewOnly = 'ViewOnly'
}
